import {Component, EventEmitter, OnChanges, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {EnvService} from "../../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "../../services/auth.service";
import {debounceTime} from "rxjs/operators";
import {MatLegacyTableDataSource as MatTableDataSource} from "@angular/material/legacy-table";
import {MatLegacyPaginator as MatPaginator} from "@angular/material/legacy-paginator";
import {SaAccessCategoryFilter} from "./saAccessCategory.filter";
import {SettingsPersistenceService} from "../../services/settings-persistence.service";

@Component({
  selector: 'micro-saAccessCategories',
  templateUrl: './saAccessCategories.component.html'
})


export class SaAccessCategoriesComponent implements OnInit {

  dataSource:MatTableDataSource<any> = new MatTableDataSource<any>();
  filter:SaAccessCategoryFilter = new SaAccessCategoryFilter();
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  reloadDebouncer:EventEmitter<any> = new EventEmitter<any>();

  pageSettings: SettingsPersistenceService;

  constructor(public auth:AuthService,
              private env:EnvService,
              private http:HttpClient) {
  }

  ngOnInit() {
    this.pageSettings = new SettingsPersistenceService(sessionStorage, "micro-sa-access-categories");
    this.pageSettings
      .setFilter(this.filter)                       // page filter object
      .setPaginator(this.paginator)                 // page paginator object
      .init();

    this.reloadDebouncer.pipe(debounceTime(50)).subscribe(change => {
      this.reloadDebounced();
    });
    this.filter.anyChange.pipe(debounceTime(500)).subscribe(change => {
      this.reload();
    });
    this.reload();
  }

  reload() {
    this.reloadDebouncer.emit();
  }

  reloadDebounced() {
    let params:HttpParams = this.filter.getParams()
      .set("page", '' + (this.paginator.pageIndex || 0))
      .set("size", '' + (this.paginator.pageSize || this.pageSettings.defaultPageSize))
    ;

    this.http.get(`${this.env.e.url}/access/categories`, {params: params}).subscribe(
      data => {
        let page = data as any;
        this.dataSource.data = page.content;
        this.paginator.pageIndex = page.number;
        this.paginator.pageSize = page.size;
        this.paginator.length = page.totalElements;
      }
    );
  }
}
